// removed by extract-text-webpack-plugin
module.exports = {"widget":"c-Widget__widget","klarnaCheckout":"c-Widget__klarnaCheckout"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Widget/Widget.scss
// module id = 835
// module chunks = 0